import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'next-i18next';

import { openAddToBasketTooltip } from '@actions/basket';

import QuantityPicker from '@common/components/QuantityPicker';

import { AddToBasketButton, QuantityLabel } from './AddToBasketForm.styled';

const AddToBasketForm = ({ articleNr, availability, onAddToBasket }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [quantity, setQuantity] = useState(1);

  const handleAddToCart = () => {
    onAddToBasket(quantity);
    dispatch(openAddToBasketTooltip());
  };

  return (
    <>
      <QuantityLabel>
        {t('shop.basket.products.amount', 'Anzahl')}
      </QuantityLabel>
      <QuantityPicker
        isDisabled={!articleNr || availability <= 0}
        setQuantity={setQuantity}
        quantity={quantity}
        max={availability}
      />
      <AddToBasketButton
        type="button"
        data-testid="addToTheBasketButton"
        onClick={handleAddToCart}
        disabled={!articleNr || availability <= 0}
      >
        {t('shop.detail.basket.button.label', 'In den Warenkorb')}
      </AddToBasketButton>
    </>
  );
};

AddToBasketForm.propTypes = {
  availability: PropTypes.number,
  articleNr: PropTypes.string,
  onAddToBasket: PropTypes.func.isRequired,
};

AddToBasketForm.defaultProps = {
  availability: 0,
  articleNr: null,
};

export default AddToBasketForm;
